<template>
    <div class="export-pop">
        <el-popover
            placement="top"
            width="500"
            popper-class="export-popover"
            trigger="click"
            @show="showExportTop"
            @hide="closeExportTop"
        >
            <div class="export-section">
                <span class="sec-title">未结束的导出任务</span>
            </div>
            <el-row v-for="(exdata, index) in runingData" v-show="runingData.length !== 0" :key="index">
                <el-col :span="6">
                    <span>{{ exdata.exportName }}</span>
                </el-col>
                <el-col :span="14">
                    <el-progress
                        :text-inside="true"
                        :stroke-width="18"
                        :percentage="exdata.progress"
                        color="#1890ff"
                    ></el-progress>
                </el-col>
                <el-col :span="4">
                    <el-button class="sec-cancel" type="text" icon="el-icon-delete" @click="exportCancel(exdata.id)"
                        >取消</el-button
                    >
                </el-col>
            </el-row>
            <div v-show="runingData.length === 0" class="no-export">
                <i class="el-icon-bell"></i>
                <p>当前没有进行中的导出任务</p>
            </div>
            <div class="export-section">
                <span class="sec-title">已完成的导出任务</span>
                <el-button class="sec-more" type="text" :loading="exporting" @click="showExportDialog">更多</el-button>
            </div>
            <div class="page-list section-body-table small">
                <el-table :data="completeData">
                    <el-table-column property="fileName" label="文件名" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" property="exportName" label="类型"></el-table-column>
                    <el-table-column width="100" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="exportDownload(scope.row.id)">下载</el-button>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column width="100" label="操作1">
                        <template slot-scope="scope">
                            <a
                                href="http://sanyprivate-1257242347.cos.ap-chengdu.myqcloud.com/exports/%E4%BB%BB%E5%8A%A1%E5%88%97%E8%A1%A82021.07.05151100.xlsx?sign=q-sign-algorithm%3Dsha1%26q-ak%3DAKIDJm8gCN23wPnXWsZf3R4Lg7kRPfmzuDpvDvuMxL_UcRork9G4aetUp4tLp2g2HcNM%26q-sign-time%3D1625469625%3B1625473225%26q-key-time%3D1625469625%3B1625473225%26q-header-list%3D%26q-url-param-list%3D%26q-signature%3Df44b1bd402d9071921b2676a88bfc2fc9d71798b&x-cos-security-token=kbw40ktb9Mf9juax1iegCVUUZ8y7V7ma9047b62020653265f3c0068b92fc1438iZCvkxcwj8l8Ikgu8XizaLatbj-Xyw-HM3ojClzPqeUt8ktFfVDl9nCirpuPxBjzwiNjZrG6pAdqS_IOFRyD6tdqLwsC8MwoNH-wc29Jsp-rLSU8dPBXbQiYcfj3y0DGi3tFy8kQdtzZALhvpe-ZV_YRus7yGxn90R0vxSVet-q-CPhnsRpykKNyYC0wDfMhQ7W_4a422KqGHVh8qQIOwdqfndHxgGlWZBXsJ9LZHpHJvCtM0gTkmIXJg3zasZvPt-CUceiZTDtGw5HxY-Ouwygn-boN5EB0cY5GaGkt0-b9E3lGN6cwHpyrGJFwhNOZmgjNUDhSwXut7drN2DQFaO-T9ucCe5ULaxyD56oXr0QA2ZS2gyBXxGFo7RBdatX_ULRpf5BhQM6Fo7Ai4kxWdcDFxatoftDmIWhdToGviaxShs9E11iBPS8aFDJ7u7dw9F4Oi3gtOTewjfw5Y6qGFz5INo236hDCwA6BKr7hCtY8nuCCnbMZOXiP3BYdThMi4-wmo2kCgnWqsEHKfnG1VYjMoDArWDfRRKJo-KsEZvt0_YMZIEFSlvlkT1enFzPlGitEqM-UYm3o0eWmR4CLfJmdZfxKN6VzppRv1JOqfaM"
                                >下载</a
                            >
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
            <div id="export-top-btn" slot="reference">下载中心</div>
        </el-popover>
        <!-- 导出组件 -->
        <el-dialog
            :append-to-body="true"
            :close-on-click-modal="false"
            :visible.sync="dialogExportVisible"
            title="我的导出任务历史"
            width="1000px"
            @close="dialogExportVisible = false"
        >
            <div class="page-list section-body-table small export-table">
                <table-list
                    :table-loading="exporting"
                    :table-data="exportTableData"
                    :table-header="exportTableHeader"
                    :page="page"
                    :page-size-click="handleSizeChange"
                    :page-num-click="handleCurrentChange"
                >
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.statusCode === 2" type="text" @click="exportCancel(scope.row.id)">
                            取消
                        </el-button>
                        <el-button v-if="scope.row.statusCode === 1" type="text" @click="exportDownload(scope.row.id)">
                            下载
                        </el-button>
                    </template>
                </table-list>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '@/api';
export default {
    name: 'ExportList',
    data() {
        return {
            exporting: false,
            completeData: [],
            runingData: [],
            dialogExportVisible: false,
            exportTableData: [],
            exportTableHeader: [
                { label: '文件名', prop: 'fileName', show: true, width: '160px' },
                { label: '类型', prop: 'exportName', show: true, width: '100px' },
                { label: '任务开始时间', prop: 'startTime', show: true, width: '150px' },
                { label: '任务结束时间', prop: 'endTime', show: true, width: '150px' },
                { label: '耗时', prop: 'occupiedTime', show: true, width: '60px' },
                { label: '过期时间', prop: 'expires', show: true, width: '150px' },
                { label: '状态', prop: 'statusName', show: true, width: '60px' },
                { label: '下载数', prop: 'downloads', show: true, minWidth: '60px' },
                { label: '操作', show: true, width: '100px', fixed: 'right' }
            ],
            page: {
                // 当前页
                pageNum: this.$utils.defaultPageNum,
                // 页尺寸
                pageSize: this.$utils.defaultPageSize,
                // 总条数
                total: 0
            }
        };
    },
    computed: {},
    created() {},
    beforeDestroy() {
        // 组件销毁前删除计时器
        // 组件销毁时有可能不触发popover的hide事件,所以需要单独处理
        this.closeExportTop();
    },
    methods: {
        // 进入导出popover界面
        showExportTop() {
            this.getExportSub();
            window.loopExport = setInterval(this.getExportSub, 1000);
        },
        // 离开导出popover界面
        closeExportTop() {
            clearInterval(window.loopExport);
            window.loopExport = null;
        },
        // 获取正在进行中的导出任务
        getExportSub() {
            let exportType = 'bizOpportunity';
            api.commonService
                .exportProgress(exportType)
                .then(res => {
                    // 对数据进行分类处理
                    let runingData = [];
                    let completeData = [];
                    res.data.length &&
                        res.data.forEach(function(item, idx) {
                            if (item.status === 2) {
                                runingData.push(item);
                            } else {
                                // 已完成的数据只显示5条
                                if (completeData.length < 5) {
                                    completeData.push(item);
                                }
                            }
                        });
                    // 渲染到页面
                    this.runingData = runingData;
                    this.completeData = completeData;
                })
                .catch(error => {
                    this.$message({
                        message: error.message || '获取正在进行中的导出任务时发生了错误',
                        type: 'error'
                    });
                });
        },
        // 显示导出的Dialog界面
        showExportDialog() {
            this.dialogTableVisible = true;
            this.getExportList();
        },
        // 获取可以分页的导出列表
        getExportList() {
            this.exporting = true;
            api.commonService
                .getExportList(this.query, this.page)
                .then(res => {
                    this.exporting = false;
                    this.dialogExportVisible = true;
                    this.exportTableData = res.data.list;
                    this.page.pageNum = res.data.pageNum;
                    this.page.pageSize = res.data.pageSize;
                    this.page.total = res.data.total;
                })
                .catch(error => {
                    this.exporting = false;
                    this.$message({
                        message: error.message || '获取导出列表时发生了错误',
                        type: 'error'
                    });
                });
        },
        // 取消导出
        exportCancel(id) {
            this.$confirm(`确定要提交当前索赔单吗?`, '保存索赔单', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            });
            this.$confirm('确定要取消该导出任务吗？', '取消确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning'
            }).then(() => {
                api.commonService
                    .exportCancel(id)
                    .then(res => {
                        this.$message({
                            message: '取消成功',
                            type: 'success'
                        });
                        this.getExportList();
                    })
                    .catch(error => {
                        this.$message({
                            message: error.message || '取消时发生了错误',
                            type: 'error'
                        });
                    });
            });
        },
        // 下载文件
        // 不能直接跳转，浏览器会拦截
        exportDownload(id) {
            api.commonService
                .exportDownload(id)
                .then(res => {
                    this.$message({
                        message: '正在下载，请稍候',
                        type: 'success'
                    });
                    // 根据defaultCategoryId判断是否是飞书环境
                    const defaultCategoryId = sessionStorage.getItem('defaultCategoryId');
                    if (defaultCategoryId) {
                        window.location.href = res.data.downloadUrl;
                    } else {
                        //这里打开窗口是异步的，得先打开新窗口，再对页面进行重定向，并且做一个window.open返回值的判断，加个校验，以免报错
                        let tempPage = window.open('', '_top');
                        setTimeout(function() {
                            if (tempPage) {
                                tempPage.location.href = res.data.downloadUrl;
                            }
                        }, 1000);
                    }
                })
                .catch(error => {
                    this.$message({
                        message: error.message || '下载时发生了错误',
                        type: 'error'
                    });
                });
        },
        /**
         * 改变页码
         * @param pageNum 新页码
         */
        handleCurrentChange(pageNum) {
            this.page.pageNum = pageNum;
            this.getExportList();
        },
        /**
         * 改变每页显示条数
         * @param pageSize 新页码大小
         */
        handleSizeChange(pageSize) {
            this.page.pageNum = 1;
            this.page.pageSize = pageSize;
            this.getExportList();
        }
    }
};
</script>
<style rel="stylesheet/css" scoped>
#export-top-btn {
    cursor: pointer;
}
.export-table {
    max-height: 526px;
    overflow: auto;
}
.export-section {
    margin-top: 10px;
    /* border-bottom:1px solid #eee; */
    padding-bottom: 15px;
    font-size: 14px;
    /* font-weight: bold; */
}
.export-section .sec-title {
    border-left: 5px solid #1890ff;
    padding-left: 15px;
}
.export-section .sec-more {
    float: right;
}
.no-export {
    margin: 30px 0;
    text-align: center;
    /* color:#606266; */
}
.no-export .el-icon-bell {
    display: inline-block;
    vertical-align: middle;
    margin-right: 15px;
    font-size: 28px;
}
.no-export p {
    display: inline-block;
    vertical-align: middle;
}
#detailDialog .el-dialog__wrapper {
    height: 100vh;
}
.sec-cancel {
    padding: 0;
    float: right;
}
</style>
